import { render } from "./CompositeVizPanel.vue?vue&type=template&id=84d0eaee&scoped=true"
import script from "./CompositeVizPanel.vue?vue&type=script&lang=js"
export * from "./CompositeVizPanel.vue?vue&type=script&lang=js"

import "./CompositeVizPanel.vue?vue&type=style&index=0&id=84d0eaee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d0eaee"]])

export default __exports__